// extracted by mini-css-extract-plugin
module.exports = {"root":"App_root__2CSG3","App":"App_App__15LM-","hr":"App_hr__2AlqY","footer":"App_footer__3csul","footer-btn":"App_footer-btn__1VxMQ"};